import React from 'react';
import CrmInteractionsListPage from './components/CrmInteractionsListPage';

export default function MeetingsPage() {
  return (
    <CrmInteractionsListPage
      pageKey="meetingsPage"
      typeFilter="meeting"
      showMeetingType
      showDealAmount
    />
  );
}
